// В development режиме используем относительные пути (через Vite proxy)
// В production используем пустую строку (относительные пути) или значение из VITE_API_URL
const API_BASE_URL =
  import.meta.env.VITE_API_URL ??
  (import.meta.env.DEV ? '' : ''); // Пустая строка = относительные пути

export default API_BASE_URL;

